// extracted by mini-css-extract-plugin
export default {"rating":"dH-z","numberOfStars":"eH-z","count":"fH-z","barGraphSpacing":"gH-z","barGraph":"hH-z"};